<template>
  <v-btn
    :loading="loading"
    :outline="outline"
    :flat="flat"
    :href="href"
    round
    block
    large
    dark
    width="20px"
    depress
    color="primary"
    class="font-weight-black caption mt-0 main-button"
    :disabled="disabled"
    :style="
      `height:50px; font-weight: 900; width: ${width ||
        '100%'}; ${additionalStyles}`
    "
  >
    <slot></slot>
  </v-btn>
</template>

<script>
export default {
  name: 'MainButton',
  props: {
    loading: Boolean,
    outline: Boolean,
    flat: Boolean,
    href: String,
    width: String,
    additionalStyles: String,
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.btn-outline {
  div {
    color: white !important;
  }
}
.main-button {
  &:before {
    width: unset;
  }
}
</style>
